// Phase 999.4 Plan 06 — Reusable warn-before-commit modal (R5 + D-15).
//
// Props (D-15 contract):
//   isOpen       — controlled by parent; modal does NOT manage its own visibility
//   label        — human-readable identifier of the change (e.g. "ZOffset for LocationID 42")
//   beforeValue  — current DB value, rendered as <code>
//   afterValue   — proposed value, rendered as <code>
//   onConfirm    — fires when Confirm clicked (parent issues the PUT)
//   onCancel     — fires when Cancel/dismiss; parent SHOULD NOT clear the unsaved
//                  draft (R5 acceptance: "form retains unsaved value")
//   busy         — when true, both buttons disabled; modal cannot be dismissed
//                  via toggle (prevents double-submit / mid-save close races)
//
// XSS: All values rendered via JSX text-interpolation — React escapes by default.
// No raw-HTML escape hatch is used in this component (no innerHTML props).

import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export function DiffConfirmModal({ isOpen, label, beforeValue, afterValue, onConfirm, onCancel, busy }) {
    return (
        <Modal isOpen={isOpen} toggle={busy ? undefined : onCancel}>
            <ModalHeader toggle={busy ? undefined : onCancel}>Confirm change</ModalHeader>
            <ModalBody>
                <p>Change <strong>{label}</strong>?</p>
                <table className="table table-sm">
                    <tbody>
                        <tr><th>Before</th><td><code>{String(beforeValue ?? '(unset)')}</code></td></tr>
                        <tr><th>After</th><td><code>{String(afterValue ?? '')}</code></td></tr>
                    </tbody>
                </table>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onCancel} disabled={busy}>Cancel</Button>
                <Button color="primary" onClick={onConfirm} disabled={busy}>
                    {busy ? 'Saving...' : 'Confirm'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DiffConfirmModal;
